// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1XIrf","grid-content":"style_grid-content__2CZwJ"};